function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmarkNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 672.05 634.15"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "checkmark-new_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h672.05v634.15H0z",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#checkmark-new_svg__a)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M317.07 634.15c175.12 0 317.08-141.95 317.08-317.08S492.19 0 317.07 0 0 141.95 0 317.08s141.95 317.08 317.08 317.08",
  style: {
    fill: "#19335a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.7 323.81c4.86 7.94 34.39 40.67 72.9 86.19 46.02 54.37 97.89 115.61 103.98 122.56 11.15 12.75 19.37 3.95 36.04-29.4 23.11-46.22 70.74-147.48 137.65-239.9 66.92-92.42 167.31-194.41 191.21-213.53s35.08-31.87 19.14-38.23c-15.93-6.39-140.38 81.63-213 160.28-77.96 84.48-162.44 222.36-183.37 225.6-16.77 2.62-97.92-58.24-120.93-72.54-26.7-16.6-56.3-21.66-43.63-1.02",
  style: {
    fill: "#fff"
  }
})));
export default SvgCheckmarkNew;